import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children, requireAdmin = false, allowWhileIntakeGated = false }) => {
  const { user, loading, requiresIntake } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Hard signup gate: when the backend told us this client must finish
  // intake before using the app, force them onto /intake-required. The
  // gate page itself uses allowWhileIntakeGated=true so it can render
  // even though the flag is on.
  if (
    requiresIntake
    && user.role === 'client'
    && !allowWhileIntakeGated
    && location.pathname !== '/intake-required'
  ) {
    return <Navigate to="/intake-required" replace />;
  }

  if (requireAdmin && user.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
